// extracted by mini-css-extract-plugin
export default {"cell":"Cells_cell__yyxKJ"};